import React, { useMemo } from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'

import S from './styled'
import { collectIngredients, findIngredient } from './utils'

import StepDetails from './stepDetails'

import {
  Checkbox,
  Loading,
} from  '../../../../components'

import { applianceSpecialTypes } from '../../../../common/appliance'

const Step = ({
  selectedStep,
  handleTranslationChange,
  locales, defaultLocale,
  stepsModel,
  field,
  ingredients,
  appliance,
  parentStep,
  parentStepPath,
  locked,
  applianceTypes,
}) => {

  const { model, checkbox } = stepsModel
  const step = _.get(model, `values[${field}].${selectedStep}`)
  const steps = useMemo(() => [
    ..._.get(model,  `values[${field}].applianceSteps.${appliance.id}.initialSteps`, []),
    ..._.get(model,`values[${field}].applianceSteps.${appliance.id}.preparationSteps`, []),
    ..._.get(model,  `values[${field}].applianceSteps.${appliance.id}.cookingSteps`, []),
    ..._.get(model,`values[${field}].applianceSteps.${appliance.id}.finalSteps`, []),
  ], [model, field, appliance.id])
  const stepPath = useMemo(() => parentStepPath ? parentStepPath : `values[${field}].${selectedStep}`, [parentStepPath, field, selectedStep])
  const stepPrefix = useMemo(() => path => `values[${field}].${selectedStep}.${path}`, [selectedStep, field])
  const stepPrefixWithParent = useMemo(() => path => parentStepPath ?
    `${parentStepPath}.${path}` :
    `values[${field}].${selectedStep}.${path}`, [parentStepPath, field, selectedStep])

  const applianceType = useMemo(() => {
    return (((applianceTypes || []).find(at => at.id === appliance.typeId) ) || { name: '' }).name
  }, [appliance.typeId, applianceTypes])

  const isCustomType = applianceSpecialTypes.includes(applianceType)

  if (!step) {
    return null
  }

  const isStepFromCurrentAppliance = selectedStep && parseInt(selectedStep.split('.')[1], 10) === appliance.id
  if (!isStepFromCurrentAppliance) {
    return <S.Placeholder style={{ height: 800, width: '100%' }}><Loading /></S.Placeholder>
  }

  const recipeIngredient = findIngredient(model, step, field)

  const currentIngredients = () => collectIngredients(model, field, ingredients, defaultLocale )

  return (
    <React.Fragment>
      <S.StepDescriptionBlock>
        <S.StepDetailsRow>
          <S.CheckboxContainer>
            <div>
              <div>
                <Checkbox {...checkbox({
                  name: stepPrefixWithParent`showTime`,
                  title: 'Show Time',
                  readOnly: !!parentStep || locked,
                })}/>
              </div>
              <S.CheckboxLine>
                <Checkbox {...checkbox({
                  name: stepPrefixWithParent`requiresUserConfirmation`,
                  title: 'Requires User Confirmation',
                  readOnly: !!parentStep || locked,
                })}/>
              </S.CheckboxLine>
              <S.CheckboxLine>
                <Checkbox {...checkbox({
                  name: stepPrefixWithParent`disableSounds`,
                  title: 'Disable Sounds',
                  readOnly: !!parentStep || locked,
                })}/>
              </S.CheckboxLine>
            </div>
            <div>
              <div>
                <Checkbox {...checkbox({
                  name: stepPrefixWithParent`disableReminder`,
                  title: 'Disable Reminder',
                  readOnly: !!parentStep || locked,
                })}/>
              </div>
              <S.CheckboxLine>
                <Checkbox {...{
                  name: stepPrefixWithParent`hasReplacement`,
                  title: 'Has Replacements',
                  value: recipeIngredient.ingredient ? recipeIngredient.ingredient.hasReplacement : false,
                  readOnly: true,
                }}/>
              </S.CheckboxLine>
              {
                !(isCustomType && ['cooking', 'preparation'].includes(step.type)) && (<S.CheckboxLine>
                  <Checkbox {...checkbox({
                    name: stepPrefixWithParent`scalable`,
                    title: 'Scalable',
                    readOnly: !!parentStep || locked,
                  })}/>
                </S.CheckboxLine>)
              }
            </div>
          </S.CheckboxContainer>
        </S.StepDetailsRow>
        <StepDetails {
        ...{
          step,
          steps,
          stepsModel,
          ingredients,
          recipeIngredient,
          currentIngredients,
          defaultLocale,
          stepPrefix,
          stepPrefixWithParent,
          handleTranslationChange,
          locales,
          stepPath,
          parentStep,
          locked,
          appliance,
          applianceTypes,
          applianceType,
          isCustomType,
        }
        }/>
      </S.StepDescriptionBlock>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  applianceTypes: state.applianceTypes.list,
})

export default connect(mapStateToProps)(Step)
